<template>
  <div class="operation-page">
    <div class="content-scroll">
      <div class="content-card">
        <div class="section">
          <h3>走路</h3>
          <img :src="ossPath + 'help/action1.gif'" class="illustration right" alt="方向示意">
          <p>游乐网——幻之大地的地图是分格的，这一点如果你玩过MUD（文字的那种）那么就不会有任何迷惑。如果没玩过，那么这里简单解释一下：地图上的每一个地点都是一格，每一格都有固定的坐标，同时格与格之间有通路，用户在地图上的移动通过走过这些通路来完成。</p>
          <p>在网站界面的右上角有一个类似船舵的图形，上面标记出的方向是当前你所在地点的所有出口，它们分别连向不同的格，只要用鼠标点击你想去的方向，你的当前地点就会随之移动到相应的新地点上。</p>
          <p>为了保证系统的严谨，我们屏蔽了IE浏览器的BACK功能，同时人为输入参数来走路的方法也是行不通的。快速移动可以通过下面介绍的"瞬间移动"来完成，同时在下一个版本中，我们争取提供用户自己编辑类似MUD里面的ailas路径，从而让大家"走"得更快！</p>
        </div>

        <div class="section">
          <h3>瞬间移动</h3>
          <img :src="ossPath + 'help/action2.gif'" class="illustration left" alt="瞬间移动">
          <p>"瞬间移动"是这个世界的快速移动手段，在城市中所有可以看到天空的地点（也就是具体建筑以外的所有地点）上，都可以进行瞬间移动（我们的用户都是超人？）。</p>
          <p>某一具体地点可以瞬间移动到的地方在界面的右下角列出，一般来说，在城市中可以移动到本城的一些重要地点和其它城市的中心广场，在城外则可以移动到各个城市的中心广场。</p>
          <p>一次瞬间移动消耗体力2，如果体力低于2就会出现"飞不动"的情况，这个时候还是去拣几个苹果吃一吃，补补身体吧（可见身体是革命的本钱）。</p>
        </div>

        <div class="section clear">
          <h3>查看个人参数</h3>
          <p>在界面的左上角，系统提供了用户随时查看自己的个人参数，包括个人资料、身上的道具列表、当前任务列表、寻物雷达、回家、以及存盘退出。</p>
          <p>这些查看的具体功能在相应的帮助主题中有介绍，这里就不再详细说了，唯一需要提醒的是，我们建议您在退出这个世界的时候选择"存盘退出"而不是直接关闭浏览器，虽然系统的后台会处理这样的意外离线并帮助您存盘，但是为了不让您的努力白费，也为了帮助降低服务器的负担，请您尽量使用"存盘退出"。当然，如果您意外断线，系统会等待您重新连线的，重新连线后将会从你断线的地点开始，任何东西都不会丢失。</p>
        </div>

        <div class="section">
          <h3>聊天</h3>
          <p>我们的世界中提供了一个在界面上的类似ICQ的交流工具，使用方法基本和ICQ一样，当然由于是IE载体的，很多地方的界面不会那么方便，这个我们今后会不断改进。</p>
          <p>这个交流工具在界面的左下方，和ICQ一样，用户只能和自己的好友聊天，一条消息只能发给某一个特定的人。在好友列表的下拉选框中列有你当前在线的好友，每一个好友在线或者离线系统都会通知您，这个时候请您及时刷新您的在线好友列表。</p>
          <p>增加好友可以使用聊天工具上面的"在线用户查询"功能，当您寻找到您想要加为好友的ID，就可以发送一个好友请求，当对方确认后，你就是他的好友了，你就可以和他说话。当然，如果你们要聊天，他也同样需要给你发一个好友请求并得到你的确认（有点麻烦，不过安全）。</p>
          <p>目前版本中，每一个用户最多可以拥有好友100人（没人会那么变态吧）。</p>
        </div>

        <div class="section clear">
          <h3>和NPC的交流</h3>
          <img :src="ossPath + 'help/action3.gif'" class="illustration right" alt="NPC交互">
          <p>每一个地点中的人物头像就是NPC，和它们的交流是用户行为的重要组成部分。</p>
          <p>交流的方式有多种多样的，点击NPC，你就会发现你可能会与他进行交谈、从他那里领取任务，向他询问某样事情、提交道具、领取工作、接受或者推掉任务等等。工作、任务、task等等都和NPC密切相关。</p>
          <p>另外，系统中的一些NPC身上隐藏着秘密，发现这些秘密需要通过询问它们各种事情，如果发现了秘密，奖赏可是"大大的有"。</p>
        </div>

        <div class="section clear">
          <h3>特殊事件</h3>
          <p>在界面右侧有"特殊事件"的列表，里面是当前地点中与NPC无关的一些事件。</p>
          <p>"特殊事件"是非常丰富的：行为方面，诸如工作、某些商店等都是特定场景的特殊事件；交流方面，则有传统社区的讨论区和聊天室；更重要的是，和整个社区融合的庞大资源（当然在当前版本还很不完全）也都在这些特殊事件当中，如果想发掘什么奇怪的东西那么就要多留意这个了。</p>
        </div>

        <div class="section">
          <h3>地上的道具</h3>
          <p>每个地点上都有散落的道具，系统会定时不断生成，想要的话拣起来就可以了（当然，不要指望从地上拣到特别贵重的东西，嘿嘿）。</p>
        </div>

        <div class="section">
          <h3>用户的家</h3>
          <p>通过"回家"选项用户可以随时回到自己的家。</p>
          <p>在家里，用户可以将身上带不下的道具放入家中的柜子里面，可以对世界中的商品进行价格和购买地点的查询。</p>
          <p>这个版本的用户的家比较简陋，在不远的将来（不远是多远？一两个月吧），家中会有各种方便的家具，比如说用来在线听歌的录音机、用来看新闻的电视等（当然，或许还会有广告BANNER......）。</p>
        </div>
      </div>
    </div>

    <div class="bottom-fixed">
      <div class="back-link">
        <router-link :to="{name:'guideIndex'}">← 返回旅游指南</router-link>
      </div>
      <div class="page-footer">
        <div class="copyright">
          ©Copyright 2019 <a href="http://www.huanzhidadi.com" target="_blank">幻之大地</a> ALL RIGHTS RESERVED. <a href="https://beian.miit.gov.cn" target="_blank" title="豫ICP备17045248号-3">豫ICP备17045248号-3</a>
        </div>
        <div class="advice">
          抵制不良游戏，拒绝盗版游戏。注意自我保护，谨防受骗上当。<br/>适度游戏益脑，沉迷游戏伤身。合理安排时间，享受健康生活。
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  export default{
    methods: {
    },
    mounted: function () {
      var _this = this;
    },
    data(){
      return {
      }
    }
  }
  
</script>
<style scoped>
.operation-page {
  flex: 1;
  min-height: 0;
  max-width: 720px;
  width: 100%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  padding: 0;
}

/* ========== 正文滚动区 ========== */
.content-scroll {
  flex: 1;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  padding: 12px 12px 0;
}

.content-card {
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
  padding: 28px 30px;
  box-sizing: border-box;
}

.section {
  margin-bottom: 24px;
}

.section:last-child {
  margin-bottom: 0;
}

.section h3 {
  margin: 0 0 10px;
  font-size: 16px;
  color: #303133;
  padding-left: 8px;
  border-left: 3px solid #409eff;
}

.section p {
  margin: 0 0 10px;
  font-size: 15px;
  line-height: 1.9;
  color: #4a4a4a;
  text-indent: 2em;
}

.section p:last-child {
  margin-bottom: 0;
}

/* 插图 */
.illustration {
  max-width: 200px;
  height: auto;
  margin-bottom: 12px;
  border-radius: 8px;
}

.illustration.right {
  float: right;
  margin-left: 16px;
}

.illustration.left {
  float: left;
  margin-right: 16px;
}

.clear::after {
  content: '';
  display: table;
  clear: both;
}

/* ========== 底部固定区 ========== */
.bottom-fixed {
  flex-shrink: 0;
  padding: 0 16px;
}

.back-link {
  text-align: center;
  padding: 10px 0;
}

.back-link a {
  font-size: 14px;
  color: #909399;
  text-decoration: none;
  transition: color 0.2s;
}

.back-link a:hover {
  color: #409eff;
}

.page-footer {
  text-align: center;
  padding-bottom: 16px;
}

.page-footer .copyright {
  font-size: 12px;
  color: #999;
  line-height: 1.6;
}

.page-footer .copyright a {
  color: #909399;
  text-decoration: none;
}

.page-footer .copyright a:hover {
  color: #409eff;
}

.page-footer .advice {
  font-size: 11px;
  color: #aaa;
  line-height: 1.7;
  margin-top: 4px;
}

/* ========== 移动端适配 ========== */
@media (max-width: 768px) {
  .content-scroll {
    padding: 8px 8px 0;
  }

  .content-card {
    padding: 20px 16px;
    border-radius: 10px;
  }

  .section {
    margin-bottom: 18px;
  }

  .section h3 {
    font-size: 15px;
  }

  .section p {
    font-size: 14px;
    line-height: 1.75;
    margin-bottom: 8px;
  }

  .illustration {
    float: none !important;
    display: block;
    max-width: 180px;
    margin: 0 auto 12px !important;
  }

  .back-link a {
    font-size: 13px;
  }

  .bottom-fixed {
    padding: 0 10px;
  }

  .page-footer .copyright {
    font-size: 10px;
  }

  .page-footer .advice {
    font-size: 10px;
  }
}
</style>
